import { render, staticRenderFns } from "./ClaimHelpList.vue?vue&type=template&id=693cc384&"
import script from "./ClaimHelpList.vue?vue&type=script&lang=js&"
export * from "./ClaimHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports